import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "skyblueBg shadowContent gateTopPanel" }
const _hoisted_3 = { class: "innerContent" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "serviceCatchCopy fs18" }, "クラウド日程調整", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "fw600 serviceCatchCopyUnder yu pointer" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { style: {"margin-top":"10px"} }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "fs16" }, [
  /*#__PURE__*/_createTextVNode(" WEB会議URL自動発行から投票機能まで"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 御社の使い方にマッチするスケジュール調整自動化ツール ")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "linkContent" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs20",
  style: {"margin-top":"3px"}
}, "ご紹介ページはこちら", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = {
  key: 2,
  class: "posAb fs12 mr40",
  style: {"bottom":"4%"}
}
const _hoisted_27 = {
  key: 0,
  class: "gateFormPanel"
}
const _hoisted_28 = { class: "innerGateFormContent" }
const _hoisted_29 = {
  key: 0,
  class: "fs24 fw200 mt10"
}
const _hoisted_30 = {
  key: 1,
  class: "centered fs16 fl submitButton lgreyBg fw400"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fw400 description" }, "日程調整が圧倒的に決まるプラットフォームです。", -1)
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "header_title fw600 centered" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "fs18 mt20" }, [
  /*#__PURE__*/_createTextVNode(" 記載のURLをクリックしてログインするか下記に送信したメールに記載の6桁のコードを入力してください。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = { class: "codeBoxes" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = {
  key: 0,
  class: "fs12 fw600 alertRed"
}
const _hoisted_40 = { class: "fs12 mc centered connectOAuthContent" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = {
  key: 0,
  class: "mt20 mb10 pad5"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_46 = {
  class: "fs12",
  style: {"bottom":"4%"}
}
const _hoisted_47 = {
  key: 1,
  class: "gateFormPanel"
}
const _hoisted_48 = { class: "innerGateFormContent" }
const _hoisted_49 = {
  key: 0,
  class: "fs24 fw200 mt10"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = {
  key: 3,
  class: "centered fs16 fl submitButton lgreyBg fw400"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "header_title fw600 centered" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "fs18 mt20" }, [
  /*#__PURE__*/_createTextVNode(" 記載のURLをクリックしてログインするか下記に送信したメールに記載の6桁のコードを入力してください。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_61 = { class: "codeBoxes" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_63 = {
  key: 0,
  class: "fs12 fw600 alertRed"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_OAuthButtons = _resolveComponent("OAuthButtons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("div", {
      class: _normalizeClass(`w100 ${!_ctx.isSP ? `posFi` : ``}`)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/email/logo512x140_white.png`),
            class: "compLogo fl"
          }, null, 8, _hoisted_4),
          _hoisted_5,
          (!_ctx.isSP)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/logo/waaqLink_logo_white_flat.gif`),
            class: "serviceLogo"
          }, null, 8, _hoisted_10),
          _hoisted_11,
          (!_ctx.isSP)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _hoisted_14))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: "serviceCatchCopyUnderInnerContent",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goLP && _ctx.goLP(...args)))
            }, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/tutorial/calendar_pc.png`),
                class: "LPContentImage"
              }, null, 8, _hoisted_16),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _hoisted_19,
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/tutorial/two_arrows_white.png`),
                    class: "",
                    style: {"width":"20px"}
                  }, null, 8, _hoisted_22),
                  _hoisted_23
                ])
              ])
            ]),
            _hoisted_24,
            _createElementVNode("button", {
              class: "fs14 pointer circle_button white skyblue fw600 goFormButton",
              style: {"width":"280px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goForm && _ctx.goForm(...args)))
            }, " 資料請求・お問い合わせはこちら ")
          ]),
          _hoisted_25,
          (!_ctx.isSP)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("a", {
                  href: "https://company.waaq.jp",
                  class: _normalizeClass(`whiteColor`),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goCompany && _ctx.goCompany(...args)))
                }, "運用会社"),
                _createTextVNode("   "),
                _createElementVNode("a", {
                  href: "/sct",
                  class: _normalizeClass(`whiteColor`),
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goSct && _ctx.goSct(...args)))
                }, "特定商取引法の表記"),
                _createTextVNode("   "),
                _createElementVNode("a", {
                  href: "/tos",
                  class: _normalizeClass(`whiteColor`),
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goTos && _ctx.goTos(...args)))
                }, "ご利用規約"),
                _createTextVNode("   "),
                _createElementVNode("a", {
                  href: "/privacy_policy",
                  class: _normalizeClass(`whiteColor`),
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goPp && _ctx.goPp(...args)))
                }, "プライバシーポリシー"),
                _createTextVNode("   "),
                _createElementVNode("a", {
                  href: "https://link.waaq.jp/help",
                  class: _normalizeClass(`whiteColor`),
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goHelp && _ctx.goHelp(...args)))
                }, "ご利用方法"),
                _createTextVNode("   "),
                _createElementVNode("a", {
                  href: "/security_policy",
                  class: _normalizeClass(`whiteColor`),
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goSecurityPolicy && _ctx.goSecurityPolicy(...args)))
                }, "情報セキュリティポリシー")
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (!_ctx.useSSO)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              (!_ctx.didSend)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("form", {
                      class: "emailContent fs12 fw600",
                      style: {"white-space":"pre-line"},
                      id: "form",
                      onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
                    }, [
                      _createVNode(_component_MdTextfieldTag, {
                        name: "メールアドレスを入力",
                        fieldStyle: _ctx.isSP ? `width:100%;` : `min-width:250px;max-width:250px;`,
                        style: _normalizeStyle(_ctx.isSP ? `height: 56px;` : `height: 56px; min-width: 250px`),
                        class: "fl fs16",
                        type: `email`,
                        value: _ctx.email,
                        onInputValue: _ctx.inputEmail,
                        onBlur: _ctx.checkEmailField,
                        errMessage: _ctx.failedMail ? `不正なメールアドレスです` : null,
                        required: ""
                      }, null, 8, ["fieldStyle", "style", "value", "onInputValue", "onBlur", "errMessage"]),
                      (!_ctx.loading)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "submit",
                            class: _normalizeClass(`pointer centered fs16 fl submitButton`),
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
                          }, " 送信 "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_30, "送信中"))
                    ], 32),
                    _hoisted_31,
                    _hoisted_32
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("h5", _hoisted_34, _toDisplayString(_ctx.email) + "に確認メールを送付しました！", 1),
                    _hoisted_35,
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.values, (val, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(`codeBox codebox_${index}`),
                          key: `${val}${index}`
                        }, [
                          _createVNode(_component_TextfieldTag, {
                            style: {"border-bottom":"solid 1px #c8c8c8"},
                            class: _normalizeClass(`arial centered ${_ctx.selectedBoxIndex == index ? `selected` : ``}`),
                            maxLength: "1",
                            type: `text`,
                            value: val,
                            onInputValue: _ctx.inputCodeBox,
                            onClickTextfield: ($event: any) => (_ctx.selectCodeBox(index)),
                            onPaste: _ctx.onPaste
                          }, null, 8, ["class", "value", "onInputValue", "onClickTextfield", "onPaste"])
                        ], 2))
                      }), 128)),
                      _hoisted_38,
                      (_ctx.invalidCode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, " コードが違います。もう一度入力し直してください。 "))
                        : _createCommentVNode("", true)
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createTextVNode(" カレンダー連携している場合は、こちらからログインもできます。 "),
              _hoisted_41,
              _hoisted_42,
              _createVNode(_component_OAuthButtons, {
                showSSO: true,
                onClickSSO: _ctx.clickSSO
              }, null, 8, ["onClickSSO"]),
              _hoisted_43
            ]),
            (_ctx.isSP)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("p", _hoisted_46, [
                    _createElementVNode("a", {
                      href: "https://company.waaq.jp",
                      class: _normalizeClass(`greyColor`),
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.goCompany && _ctx.goCompany(...args)))
                    }, "運用会社"),
                    _createTextVNode("   "),
                    _createElementVNode("a", {
                      href: "/sct",
                      class: _normalizeClass(`greyColor`),
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.goSct && _ctx.goSct(...args)))
                    }, "特定商取引法の表記"),
                    _createTextVNode("   "),
                    _createElementVNode("a", {
                      href: "/tos",
                      class: _normalizeClass(`greyColor`),
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.goTos && _ctx.goTos(...args)))
                    }, "ご利用規約"),
                    _createTextVNode("   "),
                    _createElementVNode("a", {
                      href: "/privacy_policy",
                      class: _normalizeClass(`greyColor`),
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.goPp && _ctx.goPp(...args)))
                    }, "プライバシーポリシー"),
                    _createTextVNode("   "),
                    _createElementVNode("a", {
                      href: "https://link.waaq.jp/help",
                      class: _normalizeClass(`greyColor`),
                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.goHelp && _ctx.goHelp(...args)))
                    }, "ご利用方法"),
                    _createTextVNode("   "),
                    _createElementVNode("a", {
                      href: "/security_policy",
                      class: _normalizeClass(`greyColor`),
                      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.goSecurityPolicy && _ctx.goSecurityPolicy(...args)))
                    }, "情報セキュリティポリシー")
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", {
                class: "pointer skyblue",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.clickBackSSO && _ctx.clickBackSSO(...args)))
              }, "<別の方法でログインする"),
              (!_ctx.didSend)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createElementVNode("div", {
                      class: "emailContent fs12 fw600",
                      style: {"white-space":"pre-line"},
                      id: "form",
                      onSubmit: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["prevent"]))
                    }, [
                      (_ctx.useSSODomain)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _createVNode(_component_MdTextfieldTag, {
                              name: "会社のドメインを入力",
                              fieldStyle: "min-width:250px;max-width:250px;",
                              style: {"height":"56px","min-width":"250px"},
                              class: "fl fs16",
                              type: `domain`,
                              value: _ctx.ssoDomain,
                              onInputValue: _ctx.inputSSODomain,
                              onEnter: _ctx.loginSSO,
                              required: ""
                            }, null, 8, ["value", "onInputValue", "onEnter"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            _createVNode(_component_MdTextfieldTag, {
                              name: "会社のメールアドレスを入力",
                              fieldStyle: "min-width:250px;max-width:250px;",
                              style: {"height":"56px","min-width":"250px"},
                              class: "fl fs16",
                              type: `email`,
                              value: _ctx.ssoEmail,
                              onInputValue: _ctx.inputSSOEmail,
                              onBlur: _ctx.checkEmailField,
                              onEnter: _ctx.loginSSO,
                              errMessage: _ctx.failedMail ? `不正なメールアドレスです` : null,
                              required: ""
                            }, null, 8, ["value", "onInputValue", "onBlur", "onEnter", "errMessage"])
                          ])),
                      (!_ctx.loading)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "submit",
                            class: "pointer centered fs16 fl submitButton",
                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.loginSSO && _ctx.loginSSO(...args)))
                          }, " 送信 "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_52, "送信中")),
                      _hoisted_53,
                      _createElementVNode("div", null, [
                        (_ctx.useSSODomain)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                              _createElementVNode("div", {
                                class: "mt20 skyblue pointer",
                                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.clickUseSSOEmail && _ctx.clickUseSSOEmail(...args)))
                              }, "会社のドメインがわかりません")
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                              _createElementVNode("div", {
                                class: "mt20 skyblue pointer",
                                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.clickUseSSOEmail && _ctx.clickUseSSOEmail(...args)))
                              }, "会社のドメインを知っています")
                            ]))
                      ])
                    ], 32),
                    _hoisted_56
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _createElementVNode("h5", _hoisted_58, _toDisplayString(_ctx.email) + "に確認メールを送付しました！", 1),
                    _hoisted_59,
                    _hoisted_60,
                    _createElementVNode("div", _hoisted_61, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.values, (val, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(`codeBox codebox_${index}`),
                          key: `${val}${index}`
                        }, [
                          _createVNode(_component_TextfieldTag, {
                            style: {"border-bottom":"solid 1px #c8c8c8"},
                            class: _normalizeClass(`arial centered ${_ctx.selectedBoxIndex == index ? `selected` : ``}`),
                            maxLength: "1",
                            type: `text`,
                            value: val,
                            onInputValue: _ctx.inputCodeBox,
                            onClickTextfield: ($event: any) => (_ctx.selectCodeBox(index)),
                            onPaste: _ctx.onPaste
                          }, null, 8, ["class", "value", "onInputValue", "onClickTextfield", "onPaste"])
                        ], 2))
                      }), 128)),
                      _hoisted_62,
                      (_ctx.invalidCode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, " コードが違います。もう一度入力し直してください。 "))
                        : _createCommentVNode("", true)
                    ])
                  ]))
            ])
          ]))
    ], 2)
  ]))
}